<template>
  <div style="width: 100%; height: 100%">
    <ManageUser></ManageUser>
    <Share></Share>
    <Map></Map>
    <SearchGeneralGeodir></SearchGeneralGeodir>
    <SideNav></SideNav>
    <DataQuality></DataQuality>
    <StreetView></StreetView>
    <Here></Here>
    <ButtonForm></ButtonForm>
    <BannerUbicasa></BannerUbicasa>
  </div>
</template>
<script>
import Map from "./Map";
import SideNav from "@/components/sidenavs/SideNav";
//import SideNav from '@/components/sidenavs/SideNav2'

import ButtonForm from "@/components/ButtonForm";
import ManageUser from "@/components/ManageUser";
import SearchGeneralGeodir from "@/components/searchGeneral/SearchGeneralGeodir";
import Doodle from "@/components/searchGeneral/Doodle";
import DataQuality from "@/components/DataQuality/DataQuality";
import StreetView from "@/components/StreetView";
import Here from "@/components/Opciones/Here";
import Share from "@/components/Opciones/Share";
import BannerUbicasa from "../components/Opciones/BannerUbicasa.vue";

export default {
  components: {
    Map,
    SideNav,
    ManageUser,
    ButtonForm,
    SearchGeneralGeodir,
    Doodle,
    DataQuality,
    StreetView,
    Here,
    Share,
    BannerUbicasa,
  },

  mounted() {
    // leer la url

    function detectMobile() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        return true;
      } else {
        return false;
      }
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function success(e) {
      localStorage.setItem("longitude", e.coords.longitude);
      localStorage.setItem("latitude", e.coords.latitude);
    }

    function error(err) {
      localStorage.clear();
    }

    if (detectMobile()) {
      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  },
};
</script>

<style>
/* MInificha general */

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  border-radius: 4px !important;
}

/*.leaflet-popup-content-wrapper, .leaflet-popup-tip {
    background: #2f2f2f !important;
    color: white !important;
}*/
/* Campos minificha Builder ***** */
/*.atributo {
    color: #8e9397!important;
	font-size: 13px;
}*/
.atributo {
  color: #979da1 !important;
  font-size: 13px;
  margin-bottom: 2px;
}

.valor {
  line-height: 1.4 !important;
  font-size: 13px;
}

/* scroll general*/
/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #9c9c9c;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #888888;
}
</style>
